/* eslint-disable */

//党员党费交纳情况-表单
export const branchOutlayPaymentForm = {
    attrs: {
        labelWidth: '180px',
        'label-position': 'left',
        rules: {
            // userUid: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // amount: [
            //     {
            //         required: true,
            //         message: '请输入',
            //         trigger: 'blur',
            //     },
            // ],
            // paymentDate: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // handler: [
            //     {
            //         required: true,
            //         message: '请输入',
            //         trigger: 'blur',
            //     },
            // ],
        },
    },
    items: [
        {
            type: 'select-remote-input',
            showType: 'select',
            label: '党员姓名',
            prop: 'userId',
            filterable: true,
            remote: true,
            paramsKey: 'name',
            remoteAction: 'getMemberListApi',
            labelName: 'name',
            valueName: 'id',
            maxlength: 20,
            showWordLimit: true,
            filterable: true,
            clearable: true
        },
        {
            label: '交纳金额（元）',
            prop: 'amount',
            type: 'input-number',
            attrs: {
                min: 0,
                max: 99999,
                precision: 0,
                controls: false,
            },
        },
        {
            type: 'datepicker',
            label: '交纳日期',
            prop: 'paymentDate',
            clearable: true,
            format: 'yyyy-MM-dd'
        },
        {
            label: '经手人',
            prop: 'handler',
            maxlength: 20,
            showWordLimit: true,
            clearable: true,
        },
    ],
}

//党员党费交纳情况-表格
export const branchOutlayPaymentCols = [
    {
        title: '党员姓名',
        key: 'name',
        tooltip: true,
        minWidth: 200,
    },
    {
        title: '交纳金额（元）',
        key: 'amount',
        tooltip: true,
        width: 160,
    },
    {
        title: '交纳日期',
        key: 'paymentDate',
        width: 240,
    },
    {
        title: '经手人',
        key: 'handler',
        width: 240,
        tooltip: true,
    },
    {
        title: '操作',
        slot: 'operation',
        width: 160,
        fixed: 'right',
        align: 'center'
    },
]

// 收支情况表 - 表单
export const branchOutlayHistoryForm = {
    attrs: {
        labelWidth: '180px',
        'label-position': 'left',
        rules: {
            // recordDate: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // title: [
            //     {
            //         required: true,
            //         message: '请输入',
            //         trigger: 'blur',
            //     },
            // ],
            // income: [
            //     {
            //         required: true,
            //         message: '请输入',
            //         trigger: 'blur',
            //     },
            // ],
            // cost: [
            //     {
            //         required: true,
            //         message: '请输入',
            //         trigger: 'blur',
            //     },
            // ],
            // accountBalance: [
            //     {
            //         required: true,
            //         message: '请输入',
            //         trigger: 'blur',
            //     },
            // ],
            // handler: [
            //     {
            //         required: true,
            //         message: '请输入',
            //         trigger: 'blur',
            //     },
            // ],
            // manager: [
            //     {
            //         required: true,
            //         message: '请输入',
            //         trigger: 'blur',
            //     },
            // ],
        },
    },
    items: [
        {
            type: 'datepicker',
            label: '日期',
            prop: 'recordDate',
            clearable: true,
            format: 'yyyy-MM-dd'
        },
        {
            label: '摘要',
            prop: 'title',
            maxlength: 100,
            showWordLimit: true,
            clearable: true,
        },
        {
            label: '收入（元）',
            prop: 'income',
            type: 'input-number',
            attrs: {
                min: 0,
                max: 99999999,
                precision: 0,
                controls: false,
            },
        },
        {
            label: '支出（元）',
            prop: 'cost',
            type: 'input-number',
            attrs: {
                min: 0,
                max: 99999999,
                precision: 0,
                controls: false,
            },
        },
        {
            label: '节余',
            prop: 'accountBalance',
            type: 'input-number',
            attrs: {
                min: 0,
                max: 99999999,
                precision: 0,
                controls: false,
            },
        },
        {
            label: '经手人',
            prop: 'handler',
            maxlength: 20,
            showWordLimit: true,
            clearable: true,
        },
        {
            label: '经费管理人员姓名',
            prop: 'manager',
            maxlength: 20,
            showWordLimit: true,
            clearable: true,
        },
        {
            label: '备注',
            prop: 'remark',
            maxlength: 100,
            showWordLimit: true,
            clearable: true,
        },
    ],
}

// 收支情况表 - 表格
export const branchOutlayHistoryCols = [
    {
        title: '日期',
        key: 'recordDate',
        tooltip: true,
        width: 150,
    },
    {
        title: '摘要',
        key: 'title',
        tooltip: true,
        minWidth: 150,
    },
    {
        title: '收入（元）',
        key: 'income',
        tooltip: true,
        width: 120,
    },
    {
        title: '支出（元）',
        key: 'cost',
        width: 120,
        tooltip: true,
    },
    {
        title: '节余',
        key: 'accountBalance',
        width: 120,
        tooltip: true,
    },
    {
        title: '经手人',
        key: 'handler',
        width: 160,
        tooltip: true,
    },
    {
        title: '经费管理人员姓名',
        key: 'manager',
        width: 180,
        tooltip: true,
    },
    {
        title: '备注',
        key: 'remark',
        width: 160,
        tooltip: true,
    },
    {
        title: '操作',
        slot: 'operation',
        width: 160,
        fixed: 'right',
        align: 'center'
    }
]